<template>
  <div>
    <div v-for="offer in results" class="search_result" :key="offer.resource_id">
      <div class="flex" :class="{ flex_align_center: !show_recruiters }">
        <link-entity :payload="offer" :additional_data="{ resource_type: 'Offer' }"></link-entity>
        <div class="horizontal_space"></div>
        <div>
          <offer-status :payload="offer"></offer-status>
        </div>
        <div class="horizontal_space"></div>
        <a @click="expenses(offer)" class="button is-info is-outlined">Expenses</a>
        <div class="horizontal_space"></div>
        <a
          @click="fees(offer)"
          class="button is-info is-outlined"
          :class="{ fees_active: offer.is_fees_applied }"
        >Fees</a>
        <div class="horizontal_space"></div>
        <p><b>תשלום:</b> {{$utils.formatSalary($offers_helper.getPayment(offer, false))}}</p>
      </div>
      <offer-recruiters v-if="show_recruiters" :payload="offer"></offer-recruiters>
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import LinkEntity from '@/components/LinkEntity'
import OfferStatus from '@/components/OfferStatus'
import OfferRecruiters from '@/components/OfferRecruiters'
export default {
  name: 'search-modal-applicants',
  props: ['results', 'show_recruiters'],
  methods: {
    fees (data) {
      this.createModal({
        component_name: 'OfferFeesForm',
        modal_title: 'Fees - ' + data.applicant_name + ' - ' + data.company.name,
        data
      })
    },
    expenses (data) {
      this.createModal({
        component_name: 'OfferExpensesForm',
        modal_title: 'Expenses - ' + data.applicant_name + ' - ' + data.company.name,
        data
      })
    },
    ...mapMutations('modals', ['createModal'])
  },
  components: {
    LinkEntity,
    OfferStatus,
    OfferRecruiters
  }
}
</script>
<style>
  .search_result {
    cursor: unset !important;
    padding-top: 10px;
    padding-bottom: 10px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }
</style>
<style scoped>
  .fees_active {
    background: seagreen !important;
    color: white !important;
    border-color: seagreen !important
  }
</style>
